export default __webpack_public_path__ + "static/media/Download_test_report.24864a58.svg";